import apiClient from "../core/HttpClient";
import { ExerciseFile } from "../models";

export default class ExerciseFileService{
    url="/ExerciseFiles";
    async getExerciseFiles(){
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });        
    }
    async getExerciseFile(id: string){
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });        
    }

    async addExerciseFile(data: ExerciseFile){
        return apiClient.post(this.url, data);
    }

    async updateExerciseFile(id: string, data: ExerciseFile){
        return apiClient.put(`${this.url}/${id}`, data);
    }

    async deleteExerciseFile(id: string){
        return apiClient.delete(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
    }
    
    
}
